import { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import { updateSavedSearchNameThunk } from "app/pages/sales-intelligence/sub-modules/advanced-search/store/effects";
import ListRenameModalTracked from "app/pages/sales-intelligence/sub-modules/opportunities/containers/ListRenameModal/ListRenameModalTrackedContainer";
import { selectOpportunityListUpdating } from "app/pages/sales-intelligence/sub-modules/opportunities/store/selectors";
import type { SavedSearchesDto } from "app/pages/sales-intelligence/modules/leads-search/sub-modules/saved-search/types/dto";

type Props = {
    list?: Readonly<SavedSearchesDto>;
    onClose(): void;
};

const SavedSearchesRenameModal = (props: Props) => {
    const { list, onClose } = props;
    const dispatch = useDispatch();
    const [isOpen, setIsOpen] = useState(false);
    const isBeingUpdated = useSelector(selectOpportunityListUpdating);

    useEffect(() => {
        setIsOpen(typeof list !== "undefined");
    }, [list]);

    async function handleRenameSubmit(name: string) {
        if (typeof list === "undefined") {
            return onClose();
        }

        const resultAction = await dispatch(updateSavedSearchNameThunk(list.id, name));

        if (resultAction) {
            onClose();
        }
    }

    return (
        <ListRenameModalTracked
            isOpen={isOpen}
            currentName={list?.name ?? ""}
            isBeingSubmitted={isBeingUpdated}
            onCancel={onClose}
            onSubmit={handleRenameSubmit}
        />
    );
};

export default SavedSearchesRenameModal;
